import _ from 'lodash';
import {$cookiesConsent} from './cookies.js';
import {str2type, type2str} from './util.js';

const storage = ()=>$cookiesConsent.get() ? localStorage : sessionStorage;

export default {
    set: (k, v)=>storage().setItem(k, type2str(v)),
    get: k=>storage().getItem(k),
    getNum: k=>str2type(storage().getItem(k), Number),
    getBool: k=>str2type(storage().getItem(k), Boolean),
    getDate: k=>str2type(storage().getItem(k), Date),
    getObject: k=>str2type(storage().getItem(k), Object),
    remove: k=>storage().removeItem(k),
    clear: ()=>{
        localStorage.clear();
        sessionStorage.clear();
    },
    migrateToLocal: ()=>{
        _.keys(sessionStorage).forEach(k=>localStorage.setItem(k, sessionStorage.getItem(k)));
        sessionStorage.clear();
    },
};
